const { getEnvironmentFromUrl } = require('@nuskin/ns-common-lib');

const config = {
  dev: {
    url: 'https://product.api.dev.nuskin.com/graphql',
    env: 'dev'
  },
  test: {
    url: 'https://product.api.test.nuskin.com/graphql',
    env: 'test'
  },
  prod: {
    url: 'https://product.api.nuskin.com/graphql',
    env: 'public'
  }
};

/**
 * Get product-api graphQL base URL based on web URL
 * @returns {string} baseUrl (default: prod env url )
 */
function graphQlUrl () {
  const env = getEnvironmentFromUrl(window.location.host);

  if (!config[env]) {
    return config['prod'].url;
  }

  return config[env].url;
}

module.exports = graphQlUrl;
